var _rect, _path, _path2, _path3, _path4, _circle, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisualSampleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 78,
    height: 57,
    rx: 4,
    stroke: "#407EDB",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 74C30.1667 74 52 74 58 74C62.5 74 65.1667 77.3333 65 79H15",
    stroke: "#407EDB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 46H15.5M30 46H79M38 6V34M38 34L33 29M38 34L43 29",
    stroke: "#407EDB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 58L26.5 74M52 74L46.5 58",
    stroke: "#407EDB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8H26M7 13H16M7 18H11",
    stroke: "#407EDB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 51,
    r: 2,
    fill: "#407EDB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 37.0018C19.0001 34.6684 18.4001 29.7018 24.0001 28.5018C24.5 25.0035 26 23.0018 30.5 23.0018C30.5 13.5001 46 13.0018 46 24.0018C60 19.5 61 39.0035 49 39.0035C42.2 39.0035 32.6667 39.0035 28 39.0035",
    stroke: "#407EDB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualSampleIcon);
export default __webpack_public_path__ + "static/media/visual_sample_icon.3843cb8548efef5d767624b485567f63.svg";
export { ForwardRef as ReactComponent };